import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import TipoArticuloGestion from './view/TipoArticuloGestion'

export const tipoArticuloRoutesMap = {
  gestion: {
    path: '/tipoArticulo/gestion',
    name: 'Tipos de Artículo',
  },
  registro: {
    path: '/tipoArticulo/nuevo',
    name: 'Nuevo Tipo Articulo',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const tipoArticuloRoutes = [
  {
    path: tipoArticuloRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <TipoArticuloGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  /*{
    path: tipoArticuloRoutesMap.upsert.path,
    element: <AlmacenRegistroApp />,
    auth: authRoles.admin,
  },*/
]

export default tipoArticuloRoutes
